/** Pragmatic email shape: something@something.tld, no spaces. */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** http(s) URL with a host (e.g. https://acme.com). */
export const URL_RE = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;

/** Exactly 5 digits (US ZIP). */
export const ZIP_RE = /^\d{5}$/;

export const isEmail = (v: string) => EMAIL_RE.test(v.trim());
export const isUrl = (v: string) => URL_RE.test(v.trim());

/** True when the value has exactly `n` digits (ignoring any formatting). */
export const digitsLen = (v: string, n: number) => v.replace(/\D/g, "").length === n;

/** True when the value has at least `n` digits (ignoring any formatting). */
export const digitsAtLeast = (v: string, n: number) => v.replace(/\D/g, "").length >= n;
